import { Navigate } from "react-router-dom";

export default function MemberFormRedirect() {
  return <Navigate to="/engage#join" replace />;
}
